import { IUpdateRawQueryListApiModel } from '@models/Update.model';
import { api } from '@services';

interface IPatchDueDate {
  id?: string;
  dueDate: Date;
  updateStatusId?: string;
}

const patchDueDate = async ({
  id,
  ...data
}: IPatchDueDate): Promise<IUpdateRawQueryListApiModel> => {
  const { data: update } = await api.patch<IUpdateRawQueryListApiModel>(
    `/updates/updateDueDate/${id}`,
    data,
  );

  return update;
};

export { patchDueDate };
